export class TextMessage {
  body: string;
  to: string;
  from: string;
  locationKey: string;
  facilityKey: string;
  apiUrl: string;
  monthYear: string; // 05-2017
};



// WEBPACK FOOTER //
// ./src/ng2/app/models/textMessage.ts